module.exports = __webpack_public_path__ + "img/close.aa610272.svg";